/**
 * 从 id-name 格式的路由参数中解析出 id
 * @param idName 格式为 "123-name" 或 "123" 的字符串
 * @returns 解析出的 id 字符串，如果解析失败返回 null
 * @example
 * parseIdFromIdName("123-name") // "123"
 * parseIdFromIdName("123a") // null
 * parseIdFromIdName("invalid") // null
 */
export function parseIdFromIdName(idName: string): string | null {
  const match = idName.match(/^(\d+)(?:-.*)?$/)
  if (!match) {
    return null
  }
  return match[1] ?? null
}

/** 解码路由段中的 URI 编码（用于 id-slug 比较） */
export function decodeRouteSegment(segment: string): string {
  try {
    return decodeURIComponent(segment)
  } catch {
    return segment
  }
}
